module.exports = __webpack_public_path__ + "img/pic4.d64623ef.png";